import React, { useState } from "react";
import AppRoutes from "./routes/routes";

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
